<template>
  <section class="c-games">
    <select-order
        v-if="ua==='sp'"
        :orderTypes="orderTypes"
        :currentOrderType="orderType"
        @selectOrderType="onSelectOrderType"
    />
    <header class="c-games_gameListHeader">
      <game-list-header
        :appCount="sortedApps.length"
        :loading="loading"
      />
      <toggle-order
        v-if="ua==='pc'"
        :orderTypes="orderTypes"
        :currentOrderType="orderType"
        @selectOrderType="onSelectOrderType"
      />
    </header>
    <div class="c-games_empty" v-if="loading">読み込み中</div>
    <GameList
      v-else
      :apps="sortedApps"
      :ua="ua"
    />
  </section>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import GameList from './organisms/GameList.vue'
import GameListHeader from './organisms/GameListHeader.vue'
import ToggleOrder from './organisms/ToggleOrder.vue'
import SelectOrder from './organisms/SelectOrder.vue'

export default {
  components: {
    GameList,
    GameListHeader,
    ToggleOrder,
    SelectOrder
  },
  props: {
    ua: String
  },
  computed: {
    ...mapGetters('apps', [
      'sortedApps'
    ]),
    ...mapState('apps', [
      'loading',
      'orderType',
      'orderTypes'
    ])
  },
  mounted () {
    this.getAllApps()
  },
  methods: {
    ...mapActions('apps', [
      'changeOrderType',
      'getAllApps'
    ]),
    onSelectOrderType (orderType) {
      this.changeOrderType(orderType)
    }
  }
}
</script>
